import Button from '@rio-cloud/rio-uikit/Button';
import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import type { MenuItemProps } from '@rio-cloud/rio-uikit/MenuItem';
import { FormattedMessage } from 'react-intl';

import type { Material } from '#domain/Material.ts';
import type { OrderSummary } from '#domain/Order.ts';
import type { OrderWithSortableKey } from '#utils/orders.util.ts';

interface OrderDetailsFooterProps {
    order: OrderWithSortableKey;
    selectedOrdersCount: number;
    materials: Material[];
    handleCancelOrder: (order: OrderWithSortableKey) => void;
    handlePlanOrder: () => void;
    handleDuplicateOrder: (order: OrderSummary, materials: Material[]) => void;
    handleEditOrder: (order: OrderSummary, materials: Material[]) => void;
}

export const OrderDetailsSidebarFooter = ({
    order,
    selectedOrdersCount,
    materials,
    handleCancelOrder,
    handlePlanOrder,
    handleDuplicateOrder,
    handleEditOrder,
}: OrderDetailsFooterProps) => {
    const cancelOrderItem: MenuItemProps = {
        value: (
            <span className='display-flex align-items-center gap-5'>
                <span className='rioglyph rioglyph-trash text-color-danger' />
                <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.orders.details.button.cancel'} />
            </span>
        ),
        onSelect: () => handleCancelOrder(order),
    };
    const duplicateOrderItem: MenuItemProps = {
        value: (
            <span className='display-flex align-items-center gap-5'>
                <span className='rioglyph rioglyph-duplicate' />
                <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.orders.duplicate-order'} />
            </span>
        ),
        onSelect: () => handleDuplicateOrder(order, materials),
    };
    const editOrderItem: MenuItemProps = {
        value: (
            <span className='display-flex align-items-center gap-5'>
                <span className='rioglyph rioglyph-pencil' />
                <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.orders.edit-order'} />
            </span>
        ),
        onSelect: () => handleEditOrder(order, materials),
    };

    return (
        <ButtonToolbar alignment={'space-between'} className={'width-100pct'}>
            {order.status !== 'open' ? (
                <Button
                    bsStyle={Button.PRIMARY}
                    iconName={'rioglyph-duplicate'}
                    autoTrackingKey='intl-msg:ordercom-cloud-frontend.orders.duplicate-order'
                    onClick={() => handleDuplicateOrder(order, materials)}
                >
                    <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.orders.duplicate-order'} />
                </Button>
            ) : (
                <ButtonDropdown
                    disabled={selectedOrdersCount > 0}
                    title={
                        <span className='display-flex align-items-center gap-5'>
                            <span className='rioglyph rioglyph-stack' />
                            <FormattedMessage
                                id={'intl-msg:ordercom-cloud-frontend.orders.plan-orders-dialog.title.one'}
                            />
                        </span>
                    }
                    bsStyle='primary'
                    dropdownClassName={'white-space-nowrap'}
                    pullRight
                    id='order-details-button-dropdown'
                    items={[editOrderItem, duplicateOrderItem, cancelOrderItem]}
                    splitButton
                    onLabelButtonClick={() => handlePlanOrder()}
                />
            )}
        </ButtonToolbar>
    );
};
